/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Typography } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";
import usePermission from "../../hooks/usePermission";
import { Notification } from "../../types/General";
import { useDeleteNotificationMutation } from "../../services/notifications";
import { showError, showToast } from "../../constants/toasts";
import {
  NOTIFICATION_TYPE,
  NOTIFICATION_TYPE_NAME,
  ROLES_NAME,
} from "../../utils/enums";
import moment from "moment";
import { handleDelete } from "../../utils/commonFunctions";
import { ConfirmationModal } from "../../Modals/confirmationModal";

interface NotificationListProps {
  rows: Notification[];
  getAllNotifications: () => void;
  isLoading: boolean;
  count: number;
  page: number;
  handlePageChange: (event: any, newPage: number) => void;
}

const NotificationsList = ({
  rows,
  getAllNotifications,
  isLoading,
  count,
  handlePageChange,
  page,
}: NotificationListProps) => {
  const { isDelete } = usePermission({
    label: "Manage Notifications",
    page_permission: "isView",
  });
  const [deleteNotification] = useDeleteNotificationMutation();
  const [selectedId, setSelectedId] = useState<string>("");

  const [openDelete, setOpenDelete] = useState(false);

  const handleDelete = async () => {
    try {
      const response = await deleteNotification({
        id: selectedId || "",
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Notification delete successfully");
      }
    } catch (error: any) {
      showError(error?.message);
      //   setIsLoading(false);
    } finally {
      getAllNotifications();
    }
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 2,
      minWidth: 200,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "type",
      headerName: "Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Box>
            <Typography>
              {row?.broadCastType
                ? NOTIFICATION_TYPE_NAME[row?.broadCastType]
                : "-"}
            </Typography>
          </Box>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "sendTo",
      headerName: "Send To",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Box>
            <Typography>
              {row?.broadCastType ? ROLES_NAME[row?.role] : "-"}
            </Typography>
          </Box>
        );
      },
    },
    {
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Box>
            <Typography>
              {row?.createdAt ? moment(row?.createdAt).format("lll") : "-"}
            </Typography>
          </Box>
        );
      },
    },
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            {isDelete && (
              <Box>
                <IconButton
                  onClick={() => {
                    setSelectedId(row?._id);
                    setOpenDelete(true);
                  }}
                >
                  <img src="/static/images/trash2_icon.svg" alt="" />
                </IconButton>
              </Box>
            )}
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          loading={isLoading}
          count={count}
          page={page}
          onPageChange={handlePageChange}
        />
      </div>
      <ConfirmationModal
        text="Are you sure to delete this notification"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />

      {/* <CommissionOfferModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
      <RejectReasonModal open={open1} onClose={handleCloseModal1} setOpen={setOpen1} /> */}
    </>
  );
};

export default NotificationsList;
